import React from "react";

/**
 * Unified estiasync brand mark: rounded icon + wordmark.
 * - size: pixel size for the square icon (wordmark scales with it)
 * - href: where the logo link goes
 * - withText: show/hide the "estiasync" text
 * - className: extra classes for outer wrapper
 *
 * Works even if Tailwind/marketing.css isn’t loaded (inline fallbacks).
 */
export default function BrandMark({
  size = 32,
  href = "/",
  withText = true,
  withIcon = true,
  className = "",
  variant = "default",
  textPx,
  tmPx,
}) {
  const imgStyle = {
    width: size,
    height: size,
    borderRadius: Math.max(10, Math.round(size * 0.28)), // ~rounded-xl
    border: "1px solid rgba(15,23,42,0.03)",             // almost invisible border
    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",             // very subtle shadow
  };

  const wordFontSize =
    textPx !== undefined && textPx !== null
      ? textPx
      : variant === "hero"
      ? "clamp(64px, 12vw, 120px)"
      : size >= 34
      ? 18
      : 16;

  const tmFontSize =
    tmPx !== undefined && tmPx !== null
      ? tmPx
      : variant === "hero"
      ? "clamp(10px, 2.2vw, 16px)"
      : Math.max(7, Math.round((typeof wordFontSize === "number" ? wordFontSize : 16) * 0.35));

  const textStyle = {
    fontSize: wordFontSize,
    fontWeight: variant === "hero" ? 700 : 600,
    letterSpacing: "-0.01em",
    lineHeight: 1,
    whiteSpace: "nowrap",
  };

  const Wrapper = href ? "a" : "div";

  return (
    <Wrapper
      {...(href ? { href } : {})}
      className={`brand-mark ${className}`}
      style={{
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        color: "#0f172a", // slate-900
        maxWidth: "100%",
        minWidth: 0,
      }}
      aria-label='estiasync home'
      title='estiasync'
    >
      {withIcon && (
        <img
          src="/bbq_service_icon.ico"
          alt="estiasync.com"
          className="brand-mark__icon"
          style={imgStyle}
        />
      )}
{withText && (
        <span style={textStyle}>
          <span style={{ color: "#0f172a" }}>estia</span>
          {/* fallback color; if /marketing.css defines .brand-sync it’ll enhance this */}
          {/* Gradient text fallback so it matches the homepage even without /marketing.css */}
			<span
            className="brand-sync"
            style={{
              marginLeft: variant === "hero" ? 10 : 2,
              background: "linear-gradient(90deg, #0ea5e9, #06b6d4, #10b981)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
            sync
          </span>
          <sup
            style={{
              fontSize: tmFontSize,
              marginLeft: 2,
              color: "#64748b",
              fontWeight: 500,
              lineHeight: 1,
    whiteSpace: "nowrap",
              display: "inline-block",
              verticalAlign: "top",
              position: "relative",
              top: variant === "hero" ? 10 : -2,
            }}
            aria-label="Trademark"
          >
            TM
          </sup>
        </span>
      )}
    </Wrapper>
  );
}
